import React, { useEffect, useRef, useState } from 'react';
import { Icons, RadioButton, ToggleContent } from '@myob/myob-widgets';
import { IntermediatePaymentCard } from 'modules/PaymentProfile/type';
import Config from 'config';
import masterCardIcon from 'assets/images/masterCard.svg';
import visaIcon from 'assets/images/visa.svg';
import americaExpressIcon from 'assets/images/americanExpress.svg';
import {
    EditBodyWrapper,
    EditHeaderWrapper,
    EditIframe,
    EditWrapper,
    IconWrapper,
} from 'modules/PaymentProfile/styles';
import { BackendPostCreditCard } from 'modules/PaymentProfile/reducers/type';

interface PCIPortholeData {
    data: {
        outcome: {
            cardDetails?: BackendPostCreditCard;
            height: number;
        };
    };
}

type FormProps = {
    isActive: boolean;
    onChange: (update: (prev: IntermediatePaymentCard) => IntermediatePaymentCard) => void;
    onHeaderClick: () => void;
};

const CreditCardForm: React.FC<FormProps> = ({ onChange, isActive, onHeaderClick }) => {
    const [iframeHeight, setIframeHeight] = useState(223);
    const refIframeContainer = useRef(null);
    useEffect(() => {
        onChange((prev): IntermediatePaymentCard => ({ ...prev, detail: undefined }));
    }, [isActive, onChange]);

    const establishIframeCommunication = () => {
        const listener = (ev: WindowEventMap['message']) => {
            if (ev.origin !== Config.PCI_CARD_PORTAL_ORIGIN) {
                return;
            }
            const data = JSON.parse(ev.data) as PCIPortholeData;
            setIframeHeight(data.data.outcome.height);
            onChange((prev): IntermediatePaymentCard => ({ ...prev, detail: data.data.outcome.cardDetails }));
        };
        window.addEventListener('message', listener, false);
        return () => window.removeEventListener('message', listener);
    };
    useEffect(establishIframeCommunication, []);
    return (
        <EditWrapper style={{ marginBottom: '1.2rem' }}>
            <ToggleContent
                visible
                renderContent={(): JSX.Element => (
                    <EditHeaderWrapper onClick={onHeaderClick}>
                        <RadioButton
                            id="creditRadio"
                            label="Credit / debit card"
                            name="creditDebitCard"
                            checked={isActive}
                            onChange={() => ({})}
                        />
                        <img src={masterCardIcon} alt="masterCard" />
                        <img src={visaIcon} alt="visa" />
                        <img src={americaExpressIcon} alt="americanExpress" />
                        <IconWrapper>{isActive ? <Icons.DownChevron /> : <Icons.UpChevron />}</IconWrapper>
                    </EditHeaderWrapper>
                )}
            >
                {isActive && (
                    <EditBodyWrapper style={{ marginBottom: 0 }}>
                        <EditIframe
                            id="edit-credit-card-iframe"
                            ref={refIframeContainer}
                            src={Config.PCI_CARD_PORTAL_URL}
                            style={{ height: iframeHeight + 'px' }}
                        />
                    </EditBodyWrapper>
                )}
            </ToggleContent>
        </EditWrapper>
    );
};

export default CreditCardForm;
